/**
 * System Entity Types — Issue #1654
 *
 * The four core domain rows that ship with every tenant as `EntityDefinition`
 * forks of platform `SystemEntityDefinitionTemplate` rows. Detail pages mount
 * `<CustomFieldsSection entityType={...}>` against these to surface inline
 * tenant-defined custom fields keyed by the parent row's id.
 */

import { z } from 'zod';

export enum SystemEntityType {
  LOAN = 'loan',
  BORROWER = 'borrower',
  APPLICATION = 'application',
  BORROWING_ENTITY = 'borrowing_entity',
}

export const SYSTEM_ENTITY_TYPES = Object.values(SystemEntityType) as SystemEntityType[];

export const SystemEntityTypeSchema = z.nativeEnum(SystemEntityType);
